import { useAuth } from '@nimbitlabs/auth';

export function useReadOnlyMode() {
  const { user } = useAuth();
  
  // User is in read-only mode if they're a Viewer or not authenticated
  const isReadOnly = !user || user.role === 'Viewer';
  
  return {
    isReadOnly,
    canEdit: !isReadOnly,
    canDelete: !isReadOnly && user?.role === 'Admin',
    canCreate: !isReadOnly,
  };
}
